/* src/app/builder-screen-beta/inspector-mode-toggle/inspector-mode-toggle.component.scss */
.inspector-mode-toggle {
  padding: 16px;
  background: #fafafa;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  margin-bottom: 16px;
}
.inspector-mode-toggle .mode-toggle-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}
.inspector-mode-toggle .mode-toggle-header .toggle-title {
  font-weight: 500;
  color: #262626;
  font-size: 14px;
}
.inspector-mode-toggle .mode-toggle-header nz-icon {
  color: #1890ff;
}
.inspector-mode-toggle .mode-radio-group {
  display: flex;
  width: 100%;
  margin-bottom: 12px;
}
.inspector-mode-toggle .mode-radio-group .mode-option {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 4px;
  min-height: 48px;
  justify-content: center;
  gap: 4px;
}
.inspector-mode-toggle .mode-radio-group .mode-option nz-icon {
  font-size: 16px;
  margin-bottom: 2px;
}
.inspector-mode-toggle .mode-radio-group .mode-option .mode-label {
  font-size: 11px;
  line-height: 1.2;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.inspector-mode-toggle .mode-radio-group .mode-option.ant-radio-button-wrapper-checked {
  background: #1890ff;
  border-color: #1890ff;
  color: white;
}
.inspector-mode-toggle .mode-radio-group .mode-option.ant-radio-button-wrapper-checked nz-icon {
  color: white;
}
.inspector-mode-toggle .mode-radio-group .mode-option.ant-radio-button-wrapper-checked .mode-label {
  color: white;
  font-weight: 500;
}
.inspector-mode-toggle .mode-radio-group .mode-option:hover:not(.ant-radio-button-wrapper-checked) {
  background: #f0f0f0;
  border-color: #d9d9d9;
}
.inspector-mode-toggle .mode-radio-group .mode-option:hover:not(.ant-radio-button-wrapper-checked) nz-icon {
  color: #1890ff;
}
.inspector-mode-toggle .mode-description .description-text {
  margin: 0;
  font-size: 12px;
  color: #595959;
  line-height: 1.4;
  display: flex;
  align-items: flex-start;
  gap: 6px;
}
.inspector-mode-toggle .mode-description .description-text nz-icon {
  color: #1890ff;
  font-size: 12px;
  margin-top: 2px;
  flex-shrink: 0;
}
@media (max-width: 768px) {
  .inspector-mode-toggle {
    padding: 12px;
  }
  .inspector-mode-toggle .mode-radio-group .mode-option {
    padding: 6px 2px;
    min-height: 40px;
  }
  .inspector-mode-toggle .mode-radio-group .mode-option nz-icon {
    font-size: 14px;
  }
  .inspector-mode-toggle .mode-radio-group .mode-option .mode-label {
    font-size: 10px;
  }
  .inspector-mode-toggle .mode-description .description-text {
    font-size: 11px;
  }
}
.inspector-mode-toggle.compact {
  padding: 12px;
  margin-bottom: 12px;
}
.inspector-mode-toggle.compact .mode-toggle-header {
  margin-bottom: 8px;
}
.inspector-mode-toggle.compact .mode-toggle-header .toggle-title {
  font-size: 13px;
}
.inspector-mode-toggle.compact .mode-radio-group {
  margin-bottom: 8px;
}
.inspector-mode-toggle.compact .mode-radio-group .mode-option {
  padding: 6px 2px;
  min-height: 40px;
}
.inspector-mode-toggle.compact .mode-radio-group .mode-option .mode-label {
  font-size: 10px;
}
.inspector-mode-toggle {
  transition: all 0.3s ease;
}
.inspector-mode-toggle .mode-radio-group .mode-option {
  transition: all 0.2s ease;
}
.mode-radio-group .mode-option:focus-within {
  outline: 2px solid #1890ff;
  outline-offset: 2px;
}
/*# sourceMappingURL=inspector-mode-toggle.component.css.map */
